var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import AccurityIcon from '../../icon/components/AccurityIcon';
var NotificationIconButton = function (_a) {
    var count = _a.count, restProps = __rest(_a, ["count"]);
    return (React.createElement(Tooltip, { title: (count === 0 ? 'No' : count) + " new notification" + (count === 1 ? '' : 's') },
        React.createElement(IconButton, __assign({}, restProps),
            React.createElement(Badge, { badgeContent: count, color: "primary" },
                React.createElement(AccurityIcon, { name: "notificationCenter", iconName: "mui:NotificationsOutlined" })))));
};
export default NotificationIconButton;
//# sourceMappingURL=NotificationIconButton.js.map